module.exports = __webpack_public_path__ + "static/media/settings-nobackground.b0e0e70c.svg";